import React from "react";
import { Text, TouchableOpacity, View } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import { Searchbar } from "react-native-paper";
import { useNavigation } from "@react-navigation/native";
import { FormattedMessage } from "react-intl";
import styles from "./styles";
import HeaderTabs from "../../components/HeaderTabs";

const SearchUsers = (props) => {
  const navigation = useNavigation();

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="searchUsers.headerBuscar" />}
        subtitle={<FormattedMessage id="marketplacecategories.subtitulo" />}
      />

      <View style={styles.content}>
        <FormattedMessage id="searchUsers.placeholderPesquisar">
          {(placeholder) => <Searchbar placeholder={placeholder} />}
        </FormattedMessage>

        <View style={styles.hr} />

        <ScrollView>
          <View style={styles.contentList}>
            <TouchableOpacity
              style={styles.contentItemList}
              onPress={() => navigation.navigate(props.route.params.page)}
            >
              <Text style={styles.initials}>
                <FormattedMessage id="searchUsers.sigla" />
              </Text>
              <View style={styles.infoUser}>
                <Text style={styles.nameUser}>
                  <FormattedMessage id="searchUsers.nomeCompleto" />
                </Text>
                <Text style={styles.emailUser}>
                  <FormattedMessage id="searchUsers.email" />
                </Text>
              </View>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.contentItemList}
              onPress={() => navigation.navigate(props.route.params.page)}
            >
              <Text style={styles.initials}>
                <FormattedMessage id="searchUsers.sigla2" />
              </Text>
              <View style={styles.infoUser}>
                <Text style={styles.nameUser}>
                  <FormattedMessage id="searchUsers.nomeCompleto2" />
                </Text>
                <Text style={styles.emailUser}>
                  <FormattedMessage id='searchUsers.email2"' />
                </Text>
              </View>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.contentItemList}
              onPress={() => navigation.navigate(props.route.params.page)}
            >
              <Text style={styles.initials}>
                <FormattedMessage id="searchUsers.sigla3" />
              </Text>
              <View style={styles.infoUser}>
                <Text style={styles.nameUser}>
                  <FormattedMessage id="searchUsers.nomeCompleto3" />
                </Text>
                <Text style={styles.emailUser}>
                  <FormattedMessage id="searchUsers.email3" />
                </Text>
              </View>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </View>
    </>
  );
};

export default SearchUsers;
